import React from 'react';
import { Box } from '@mui/material';
import SearchSimple from '../../../../../../components/SearchSimples/SearchSimple';
import CustomTable from '../../../../../../components/table/CustomTable';
import { CustomSelect } from '../../../../../../components/CustomSelect';
import PayrollHistoryTableApp from '../Functionality/PayrollHistoryTableApp';
import PayrollSubViewOptions from '../PayrollUserDetails/SubComponents/PayrollSubViewOptions';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Payroll list for past periods, filterable by year and period.
 */
const PayrollHistoryTable = ({
    subView,
    changeSubView,
    option,
    setBodyForExport,
    searchElement,
    setSearchElement,
    setSimpleSearch,
    search,
    setSearch,
    modified,
    setModified,
    activeStep,
    setExportReady,
}) => {

    const {
        setResults,
        rowsPerPage,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        getActionsButtons,
        year,
        setYear,
        period,
        setPeriod,
        yearList,
        periodList,
        getData
    } = PayrollHistoryTableApp({
        searchElement,
        setBodyForExport,
        option,
        modified,
        setModified,
        activeStep,
        setExportReady,
        subView
    });

    return (
        <>
            <div className='d-flex align-items-center gap-3 mb-4'>
                <PayrollSubViewOptions subView={subView} changeSubView={changeSubView} />
                <div className='w-100'>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        search={search}
                        setSearch={setSearch}
                        rowsPerPage={rowsPerPage}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={null}
                        supplierId={null}
                        callApi={() => getData(0, { searchElement })}
                        resetApi={() => getData(0, { searchElement: '' })}
                    />
                </div>
            </div>

            <div className='row'>
                <Box className='col-sm-12 col-md-3 px-1'>
                    <CustomSelect
                        id='slt_pht_year'
                        name='year'
                        trans='year'
                        list={yearList}
                        value={year}
                        keyName='value'
                        onChange={setYear}
                        marginBottom={false}
                        showNoSelectionOption={false}
                        required={true}
                    />
                </Box>
                <Box className='col-sm-12 col-md-3 px-1'>
                    <CustomSelect
                        id='slt_pht_period'
                        name='period'
                        trans='period'
                        list={periodList}
                        value={period}
                        keyName='value'
                        onChange={setPeriod}
                        marginBottom={false}
                        showNoSelectionOption={false}
                        required={true}
                    />
                </Box>
            </div>

            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={false}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                textNotInformation={(year === null ||  period == null) ? 'you_must_select_a_year_and_period': 'no_records_available'}
            />
            {pagination()}
        </>
    );
};

export default PayrollHistoryTable;
